import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class NotificationTemplateService extends BaseService{
	constructor() {
		super('/NotificationTemplate');
	}

	public deleteList(list: number[]) {
		return this.deleteListWithResourceName(list, 'delete-list')
	}

	public getAllByFilter(filter: NotificationTemplateFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class NotificationTemplateFilter extends BaseFilter{
	constructor(idTenant?: number | null, inPriceList?: boolean | null, identifierTemplate?: string | null  ) {
		super();
		this._idTenant = idTenant;
		this._inPriceList = inPriceList;
		this._identifierTemplate = identifierTemplate;
	}

	private _idTenant?: number | null;
	private _inPriceList?: boolean | null;
	private _identifierTemplate?: string | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._inPriceList != null ? { InPriceList: this._inPriceList } : {}),
			(this._identifierTemplate != null ? { IdentifierTemplate: this._identifierTemplate } : {})

		);
		
		return data;
	};
}